import * as H from 'history'
import { metrics } from 'component-library/__styling/settings'

import { layout } from 'thewest/App.routing'
import { BaseClientConfig } from 'common/client/BaseClientConfig'
import { PageType, createPageDefinition, GetRouteAdTargeting } from 'common/routing/page-definition'
import { billboardLeaderboardMrec } from '../ad-units'
import { ProfileV4DTO } from 'publication-types'
import { clipStringToLength } from 'common/helpers/clip-string-to-length'
import { Store, AnyAction } from 'redux'
import { AppState } from 'common/store'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'

export interface Props {
    profile: ProfileV4DTO
    config: BaseClientConfig
    getAdTargeting: GetRouteAdTargeting
    location: H.Location<any>
    section: TheWestSection
    store: Store<AppState, AnyAction>
}

export const getProfilePageRouteInfo = ({
    profile,
    section,
    config,
    getAdTargeting,
    location,
}: Props): PageType<typeof layout, TheWestSection> => {
    const adTargeting = getAdTargeting('profile', section, profile.slug)
    // Profiles need this to point back to the west - hence we don't build the url from section domains
    const profileUrl = `${config.publicUrl}${location.pathname}`

    return createPageDefinition<typeof layout, TheWestSection>(
        {
            heading: 'Profiles',
            hideHeading: true,
            pageType: 'profile',
            pageMeta: {
                title: `${profile.name} | ${profile.position}`,
                description: profile.biography
                    ? clipStringToLength(profile.biography, 160)
                    : 'Journalist profile from The West Australian',
                link: [
                    {
                        rel: 'canonical',
                        href: profileUrl,
                    },
                ],
            },
            adTargeting,
            section,
        },

        {
            type: 'box',
            props: {
                containerWidth: metrics.thewest.mainContentWidth,
                horizontalGutters: 'outerMargin',
                verticalGutters: ['outerMargin', 'outerMargin'],
            },
            contentAreas: {
                main: [
                    {
                        type: 'profile',
                        props: { profile, profileUrl },
                    },
                    layout.component({
                        type: 'lima',
                        props: {
                            fixedRatios: ['16:9'],
                            verticalSpacing: 'md',
                            hasBackground: true,

                            dataDefinitionArgs: {
                                type: 'listing',
                                topics: [],
                                authors: [profile.slug],
                                paging: {
                                    page: 1,
                                    pageSize: 12,
                                },
                            },
                        },
                    }),
                    ...billboardLeaderboardMrec('one', metrics.thewest.margins.md),
                ],
            },
        }
    )
}
